import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { locationSelector } from './location.selector';

export const locationStateSelector = createCachedSelector(
  [
    path(locationSelector).state(),
  ],
  (state) => {
    return state;
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: defaultKeySelector,
});
